import { useId, type ReactNode } from 'react';
import { X } from 'lucide-react';
import { useT } from '../i18n';
import { IconButton } from './IconButton';
import { Overlay } from './Overlay';
import s from './Drawer.module.css';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
}

/** Panneau latéral ancré en fin de ligne (droite en LTR, gauche en RTL). */
export function Drawer({ open, onClose, title, description, children, footer }: DrawerProps) {
  const { t } = useT();
  const titleId = useId();
  return (
    <Overlay open={open} onClose={onClose} labelledBy={titleId} backdropClass={s.backdrop} panelClass={s.panel}>
      <header className={s.header}>
        <div>
          <h2 id={titleId} className={s.title}>
            {title}
          </h2>
          {description && <p className={s.desc}>{description}</p>}
        </div>
        <IconButton label={t('ui.close')} icon={<X size={18} />} size="sm" onClick={onClose} />
      </header>
      <div className={s.body}>{children}</div>
      {footer && <footer className={s.footer}>{footer}</footer>}
    </Overlay>
  );
}
